import Image from 'next/image';


const EmptyComponent = ({ mt, message }) => {
   return (
      <div className='flex flex-col items-center justify-center w-full font-semibold'>
         <Image
            src={'https://playo-website.gumlet.io/playo-website-v2/Layer+2.svg'}
            width={300}
            height={300}
            objectFit='contain'
         />
         <div className={`absolute ${mt ? `${mt}` : `mt-36`}`}>{message}</div>
      </div>
   );
};

export default EmptyComponent;
